import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {  OAuthService } from 'angular-oauth2-oidc';
import { SharedDataService } from 'ngx-paf-common';

@Component({
  selector: 'openid-logout',
  templateUrl: './openid-logout.component.html',
  styleUrls: ['./openid-logout.component.scss']
})
export class OpenidLogoutComponent implements OnInit {

  constructor(
    private authSvc:OAuthService,
    private oauthService: OAuthService,
    public sharedDatas: SharedDataService,
    private router: Router) { }

  ngOnInit(): void {
  }

  async logout() {
    // Will redirect to Okta to end the session then redirect back to the configured `postLogoutRedirectUri`
    
    this.oauthService.revokeTokenAndLogout({
      client_id: this.oauthService.clientId,
      returnTo: this.oauthService.postLogoutRedirectUri
    }, true);
    
  }
}
